import React, { useEffect } from 'react';
import { ErrorBoundary, useError } from '@mrkt/features/Platform';
import { useCurrentUser } from '../../../features/currentUser';
import { Header, FlyOutToggle } from '../../../shared/components/Header';
import { usePageLocation } from '../../../features/page';

const fallback = (
  <Header>
    <FlyOutToggle avatar={null} name={null} />
  </Header>
);

function HeaderError() {
  const [, clearError] = useError();
  const location = usePageLocation();

  // clear error on location change
  useEffect(() => {
    return () => {
      clearError();
    };
  }, [location, clearError]);

  return fallback;
}

type Props = {
  children: React.ReactNode;
};

export function PageRouteHeader({ children }: Props) {
  const currentUser = useCurrentUser();

  // don't render header if logged out
  if (!currentUser) {
    return null;
  }

  return (
    <React.Suspense fallback={fallback}>
      <ErrorBoundary name="s4a-page-header" fallback={<HeaderError />}>
        {children}
      </ErrorBoundary>
    </React.Suspense>
  );
}
